<rw-modal
  modalId="azureCredentialsModal"
  datapendoid="azure-credentials-modal"
  datatestid="azure-credentials-modal"
  [title]="'Azure credentials'"
  [arialabel]="'Azure credentials'"
  [dismissible]="false"
  size="lg"
  #modalRef
> 
  <div modal-body>
    <p>Your Azure login is different from your Rightworks login. You will need to remember your password in order to access your Azure Account.</p>
    <br><p>
      <span class="azureEmailText">Azure email login:</span>  {{entraUPN}}
      <app-button 
                id="azurecredentials-copytoclipboard-button"
                label="Copy to clipboard"
                [tooltiptext]="'Copy to clipboard'"
                noContentPadding="true"
                buttonStyle="addUserTeritary"
                [arialabel]="'copy to clipboard button'"
                [datapendoid]="'azurecredentials-copytoclipboard-button'"
                [datatestid]="'azurecredentials-copytoclipboard-button'"
                [iconclass]="'fa-regular fa-clone'"
                (clickActionEmitter)="copyUPNToClipboard()"></app-button>
    </p>
  </div>
  <div modal-footer>
    <app-button
      id="btnCancel"
      label="CANCEL"
      noContentPadding="true"
      buttonStyle="addUserTeritary"
      (clickActionEmitter)="close()"
    >
    </app-button>
  </div>
</rw-modal> 
